<template>
    <div
        class="w-full h-full px-4 lg:px-8 pt-4 pb-8 rounded-lg border border-slate-200 flex flex-col justify-start items-start"
        :style="{
            backgroundImage:
                'linear-gradient(to bottom, rgba(248, 250, 252, 1) 0%, rgba(255, 255, 255, 1) 10%)',
        }"
    >
        <!-- start header -->
        <div class="self-stretch justify-start items-center gap-2 inline-flex">
            <div class="text-slate-800 text-sm font-medium leading-tight">
                {{ heading }}
            </div>
        </div>
        <!-- end header -->
        <div class="w-full pt-4 pb-4 lg:pb-8 flex justify-center items-center">
            <div
                class="w-full h-px bg-gradient-to-r from-slate-100 via-slate-200 to-slate-100"
            ></div>
        </div>

        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        heading: {
            type: String,
            required: true,
        },
        width: {
            type: String,
            required: false,
            default: '28%',
        },
    },
    setup() {
        return {};
    },
};
</script>
